import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useHealth } from "@/context/HealthAuthContext";
import { hError } from "@/lib/health";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function HealthSignup() {
  const { signup } = useHealth();
  const navigate = useNavigate();
  const [f, setF] = useState({ name: "", email: "", mobile: "", password: "", gender: "", dob: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    setBusy(true);
    try { await signup(f); navigate("/health/app"); }
    catch (err) { toast.error(hError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-gradient-to-b from-emerald-50 to-white px-4 py-10" data-testid="health-signup">
      <div className="w-full max-w-md">
        <Link to="/health" className="flex items-center justify-center gap-2 font-display font-bold text-emerald-700 text-lg mb-6"><ShieldCheck className="h-6 w-6" /> Mediva Health</Link>
        <div className="bg-white border border-emerald-100 rounded-2xl p-7 shadow-sm">
          <h1 className="text-xl font-semibold text-slate-900">Create your account</h1>
          <p className="text-sm text-slate-500 mt-1">Your private vault for you and your family.</p>
          <form onSubmit={submit} className="mt-5 space-y-4">
            <div className="space-y-1.5"><Label>Full name</Label><Input value={f.name} onChange={set("name")} required data-testid="signup-name" /></div>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1.5"><Label>Email</Label><Input type="email" value={f.email} onChange={set("email")} required data-testid="signup-email" /></div>
              <div className="space-y-1.5"><Label>Mobile</Label><Input value={f.mobile} onChange={set("mobile")} required data-testid="signup-mobile" /></div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1.5"><Label>Gender</Label>
                <select className="w-full h-9 rounded-md border border-slate-300 px-3 text-sm bg-white" value={f.gender} onChange={set("gender")} data-testid="signup-gender">
                  <option value="">—</option><option>Male</option><option>Female</option><option>Other</option>
                </select>
              </div>
              <div className="space-y-1.5"><Label>Date of birth</Label><Input type="date" value={f.dob} onChange={set("dob")} data-testid="signup-dob" /></div>
            </div>
            <div className="space-y-1.5"><Label>Password</Label><Input type="password" value={f.password} onChange={set("password")} required data-testid="signup-password" /></div>
            <Button type="submit" disabled={busy} className="w-full bg-emerald-600 hover:bg-emerald-700" data-testid="signup-submit">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Create account"}</Button>
          </form>
          <p className="text-sm text-slate-500 mt-5 text-center">Already have an account? <Link to="/health/login" className="text-emerald-700 font-medium" data-testid="to-login">Log in</Link></p>
        </div>
      </div>
    </div>
  );
}
